<template>
  <div id="offer-contract">
    <h1 class="page-title p-b-20">{{ $t('OfferContract.title') }}</h1>
    <div>
      <offer-list v-if="offers"
                  :isManager="isManager"
                  :offers="offers"
                  :status="'validated'"
                  :actionColumn="false"
                  :activateShowDetails="false"
                  :showOnlySelectedOffers="showOnlySelectedOffers"
                  :showSelectOfferColumn="showSelectOfferColumn"
                  :showReplacementMotive="true"
                  @offersPageChanged="pageChanged"
                  @offersSortChanged="sortChanged"
                  @selectedOfferChanged="selectedOfferChanged">
      </offer-list>
    </div>

    <offer-contract-missing-fields v-if="showMissingFieldsForm"
                                   :missingFields="missingFields"
                                   @validateEnteredValues="validateValuesForMissingFields" />

    <div class="pull-right row m-t-50 m-r-10">
      <div v-if="showOnlySelectedOffers">
        <button @click="selectNewOffer" class="btn btn-select-offer btn-primary btn-cons m-t-10" v-if="hasManyAvailableOffers">
          {{ $t('OfferContract.buttons.add_offer') }}
        </button>
        <button @click="generateContract" class="btn btn-genarate btn-cons m-t-10" v-bind:disabled="hasMissingFields">
          {{ $t('OfferContract.buttons.generate_contract') }}
        </button>
      </div>
      <div v-else>
        <button @click="cancelOfferSelection" class="btn btn-primary btn-cancel btn-cons m-t-10">
          {{ $t("buttons.cancel") }}
        </button>
        <button @click="addSelectedOffer" class="btn btn-validate btn-cons m-t-10 pull-right" v-bind:disabled="!selectedOfferId">
          {{ $t('OfferContract.buttons.validate') }}
        </button>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
</template>

<script>
import OfferList from './OfferList';
import OfferContractMissingFields from './OfferContractMissingFields';
import { mapGetters, mapActions } from 'vuex';
import { checkRoleManager } from '@/helpers/roles';
import offers_mixin from '@/mixin/offers';
import moment from 'moment';

export default {
  mixins: [offers_mixin],
  name: 'OfferContract',
  components: { OfferList, OfferContractMissingFields },
  data: function() {
    return {
      offers: null,
      selectedOfferId: null,
      showOnlySelectedOffers: true,
      showSelectOfferColumn: false
    }
  },
  computed: {
    ...mapGetters({
      offer: 'offers/offer',
      currentUser: 'auth/currentUser',
      missingFields: 'contracts/missingFields',
      selectedOfferIds: 'contracts/selectedOfferIds',
    }),
    offerId: function() {
      return parseInt(this.$route.params.id);
    },
    entityId: function() {
      return this.offer.entity.id;
    },
    templateId: function() {
      return parseInt(this.$route.params.contract_id);
    },
    candidateId: function() {
      if(this.offer.applied_candidates[0] != undefined) {
        return this.offer.applied_candidates[0].user_info.id;
      }
    },
    hasMissingFields: function() {
      return this.missingFields && this.missingFields.length > 0;
    },
    hasManyAvailableOffers: function() {
      return (
        this.offers !== null &&
        this.offers.data !== undefined &&
        this.offers.data.length > 1
      );
    },
    showMissingFieldsForm: function() {
      return this.hasMissingFields && this.showOnlySelectedOffers;
    },
    isManager: function() {
      return checkRoleManager(this.currentUser.role);
    },
    startDate: function() {
      return moment(this.offer.start_at).subtract(7, 'days').format('DD-MM-YYYY');
    },
    otherOfferIds: function() {
      return this.selectedOfferIds.filter(offerId => offerId !== this.offerId);
    }
  },
  mounted() {
    this.clearMissingFields();
    this.validateOfferForContractTemplate({
      offerId: this.offerId,
      templateId: this.templateId
    });
    this.selectedOfferId = this.offerId;
  },
  methods: {
    ...mapActions({
      getOffer: 'offers/getOffer',
      loadOfferList: 'offers/loadOfferList',
      addOfferId: 'contracts/addOfferId',
      validateOfferForContractTemplate: 'contracts/validateOfferForContractTemplate',
      clearMissingFields: 'contracts/clearMissingFields',
      clearSelectedOfferIds: 'contracts/clearSelectedOfferIds',
      updateContractFields: 'contracts/updateContractFields',
    }),
    buildParams: function() {
      this.filters['start_at_gteq'] = this.startDate;
      this.filters['replaced_occupation_id_in'] = [this.offer.replaced_occupation_id];
      this.filters['entity_id_in'] = this.entityId;
      return {
        status:         'validated',
        future:         false,
        page:           1,
        filters:        this.filters,
        candidate_id:   this.candidateId,
      };
    },
    selectNewOffer: function() {
      this.sortOffers();
      this.showOnlySelectedOffers = false;
      this.showSelectOfferColumn = true;
    },
    initTab: async function() {
      this.clearSelectedOfferIds();
      this.addOfferId(this.offerId);
      await this.getOffer(this.offerId);
      await this.loadOfferList(this.buildParams());
      this.offers = this.offerList;
    },
    sortOffers: function() {
      this.offers.data.sort((a, b) => {
        const offerId = parseInt(a.id);
        if(this.offerId == offerId) {
          return -1;
        }
        return 1
      })
    },
    selectedOfferChanged: function(offerId) {
      this.selectedOfferId = offerId;
    },
    displayRecapOfSelectedOffers: function() {
      this.selectedOfferId = null;
      this.showOnlySelectedOffers = true;
      this.showSelectOfferColumn = false;
    },
    addSelectedOffer: function() {
      if(this.selectedOfferId && this.offerId !== this.selectedOfferId) {
        this.addOfferId(this.selectedOfferId);
      }
      this.displayRecapOfSelectedOffers();
    },
    cancelOfferSelection: function() {
      this.displayRecapOfSelectedOffers();
    },
    generateContract: function() {
      this.$router.push({
        name: 'ContractPreview',
        params: { id: this.offerId, contract_id: this.templateId },
        query: { offer_ids: this.otherOfferIds }
      });
    },
    validateValuesForMissingFields: async function(updatedFields) {
      await this.updateContractFields({
        offerId: this.offerId,
        templateId: this.templateId,
        updatedFields: updatedFields
      });
      this.loadOfferList(this.buildParams());
    }
  }
}
</script>

<style lang="scss" scoped>
  .btn-genarate, .btn-validate {
    color: white;
    background-color: #e51349;
    border-color: #e51349;
  }
  .message {
    font-size: 0.8rem;
    text-transform: uppercase;
    text-shadow: 0 0 #8E9AA2;
  }
</style>



// WEBPACK FOOTER //
// src/components/offers/OfferContract.vue